export { default as CoreModelCard } from './component';
